import { useParams, useSearchParams } from 'react-router-dom'
import useEquipment from '@/pages/Equipment/hooks/useEquipment.ts'
import { useEffect, useState } from 'react'
import liftMonitoringEventEmitter from '@/pages/Equipment/pages/LiftPage/pages/LiftMonitoring/liftMonitoring.eventEmitter.ts'
import liftChartEventEmitter from '@/pages/Equipment/pages/LiftPage/pages/LiftMonitoring/liftChart.eventEmitter.ts'
import MainLayout from '@/shared/Layouts/MainLayout'
import css from '@/pages/Equipment/pages/LiftPage/pages/LiftMonitoring/lifMonitoring.module.css'
import NavigationBreadcrumbs from '@/navigation/components/NavigationBreadcrumbs'
import urls from '@/navigation/urls.ts'
import equipmentUtils from '@/pages/Equipment/equipment.utils.ts'
import AntDatePicker from '@/shared/Inputs/DatePickers/AntDatePicker'
import Toggle from '@/shared/Inputs/Toggle'
import LiftAnalysisContent from '@/pages/Equipment/pages/LiftPage/pages/LiftAnalysis/LiftAnalysisContent'
import useTitle from '@/shared/hooks/useTitle'

const LiftAnalysis = () => {
  const liftId = +useParams().id
  const equipment = useEquipment(+liftId)
  useTitle(
    equipment
      ? `Анализ — ${equipmentUtils.getEquipmentAddress(equipment.location, {
          includeCountry: false,
          includeCity: true,
          includeRegion: false,
          includeAddress: true,
        })}`
      : 'Анализ'
  )

  const [query] = useSearchParams()
  let queryTs = +query.get('ts') || null

  const [isLive, setIsLive] = useState(!Boolean(queryTs))
  const [selectedDate, setSelectedDate] = useState(queryTs ? new Date(queryTs) : new Date())

  const handleLiveChange = (value: boolean) => {
    setIsLive(value)
    liftMonitoringEventEmitter.next({ state: { live: value, ts: Date.now() } })
  }

  const handleDateSelect = (ts: number) => {
    setSelectedDate(new Date(ts))
    liftMonitoringEventEmitter.next({ state: { live: false, ts } })
  }

  useEffect(() => {
    liftChartEventEmitter.subscribe((event) => {
      setIsLive(event.state.live)
      setSelectedDate(new Date(event.state.ts))
    })
  }, [])

  return (
    <MainLayout>
      <div className={css.wrapper}>
        <NavigationBreadcrumbs
          withBackButton={true}
          crumbs={[
            { id: 1, to: null, title: 'Оборудование' },
            { id: 1, to: null, title: 'Лифт' },
            {
              to: urls.liftScreen(equipment.id),
              id: 2,
              title: equipmentUtils.getEquipmentAddress(equipment.location, {
                includeCountry: true,
                includeRegion: true,
              }),
              replace: true,
            },
            { id: 3, title: 'Анализ', to: null },
          ]}
        />
        <div className="flex-space-between width100">
          <div className="inline-flex-gap mt16">
            <h3 className="text-heading-3">Анализ</h3>
          </div>
          <div className="inline-flex-gap gap16 mt16" style={{ height: '32px' }}>
            <AntDatePicker
              style={{ width: '200px' }}
              disabled={isLive}
              selectedTs={isLive ? undefined : selectedDate.getTime()}
              onChange={handleDateSelect}
              withTime={true}
              allowSelectInFuture={false}
              format="DD.MM.YYYY HH:mm:ss"
            />
            <div className="inline-flex-gap gap8 center" style={{ flexShrink: 0 }}>
              <Toggle name="live" checked={isLive} onChange={handleLiveChange} size="large" />
              <p className="text-nm">Онлайн</p>
            </div>
          </div>
        </div>

        <LiftAnalysisContent isLive={isLive} selectedDate={selectedDate} equipmentId={liftId} />
      </div>
    </MainLayout>
  )
}

export default LiftAnalysis
